namespace RioERP.Reports {
    export interface OrderInstallmentReportForm {
        OrderId: Serenity.IntegerEditor;
        OrderDate: Serenity.DateEditor;
        OrderNumber: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        CustomerMobile1: Serenity.StringEditor;
        CustomerEmail1: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductSpecificationName: Serenity.StringEditor;
        InstallmentDate: Serenity.DateEditor;
        GrossAmount: Serenity.DecimalEditor;
        InstallmentAmount: Serenity.DecimalEditor;
    }

    export class OrderInstallmentReportForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.OrderInstallmentReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrderInstallmentReportForm.init)  {
                OrderInstallmentReportForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(OrderInstallmentReportForm, [
                    'OrderId', w0,
                    'OrderDate', w1,
                    'OrderNumber', w2,
                    'CustomerName', w2,
                    'CustomerMobile1', w2,
                    'CustomerEmail1', w2,
                    'ProductName', w2,
                    'ProductSpecificationName', w2,
                    'InstallmentDate', w1,
                    'GrossAmount', w3,
                    'InstallmentAmount', w3
                ]);
            }
        }
    }
}
